import { convertParhato2Category } from "./converters";
import { BaseCategoriesClient, BaseClientResponse } from "@core/types";
import { SupaCategory } from "../types/supabaseFragments";

const CATEGORIES_PER_PAGE = 100;

class CategoriesClient extends BaseCategoriesClient {
  async getAllCategories() {
    let page = 1;
    let response: BaseClientResponse<SupaCategory[]>;
    let allCategories: SupaCategory[] = [];
    do {
      response = await this.instance.get<SupaCategory[]>("/wp-json/wc/v3/products/categories", {
        params: {
          per_page: CATEGORIES_PER_PAGE,
          page: page,
        },
      });
      page++;
      allCategories = [...allCategories, ...response.data];
    } while (response.data.length >= 100);

    const allCat = allCategories.map(convertParhato2Category);
    const subCategories = allCat.filter((x) => x.parent !== "0");
    const mainCategories = allCat.filter((x) => x.parent === "0");

    return { allCategories: allCat, subCategories, mainCategories };
  }

  async getMainCategories() {
    const response = await this.instance.get<SupaCategory[]>("/wp-json/wc/v3/products/categories", {
      params: {
        per_page: CATEGORIES_PER_PAGE,
        parent: "0",
      },
    });
    return response.data.map(convertParhato2Category);
  }

  async getSubCategories(id: string) {
    const response = await this.instance.get<SupaCategory[]>("/wp-json/wc/v3/products/categories", {
      params: {
        per_page: CATEGORIES_PER_PAGE,
        parent: id,
      },
    });
    return response.data.map(convertParhato2Category);
  }

  async getCategoryById(id: string) {
    const response = await this.instance.get<SupaCategory[]>(`/wp-json/wc/v3/products/categories?include=${id}`);
    return !!response?.data?.length ? convertParhato2Category(response.data[0]) : null;
  }
}

export default CategoriesClient;
